import React from 'react';
import PropTypes from 'prop-types';
import Title from '../../common/Title';

export default class OverviewSection extends React.Component {

  render() {
    return (
      <div>
        <Title text="Overview" />
        <div dangerouslySetInnerHTML={{__html: this.props.serviceDescription}} />
      </div>
    );
  }
}

OverviewSection.propTypes = {
  serviceDescription: PropTypes.string.isRequired
};
